/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WordleGameResponse = {
    /**
     * Arcade play ID
     */
    playId: string;
    /**
     * Game status: 0=in_progress, 10=completed, 20=timed_out
     */
    status: WordleGameResponse.status;
    /**
     * Array of guessed words
     */
    guesses: Array<string>;
    /**
     * Feedback arrays: 0=absent, 1=present, 2=correct
     */
    feedback: Array<Array<0 | 1 | 2>>;
    /**
     * Number of attempts left
     */
    attemptsRemaining: number;
    /**
     * Whether the game is complete
     */
    gameOver: boolean;
    /**
     * Whether user won (only if gameOver)
     */
    won?: boolean | null;
    /**
     * The correct answer (only if gameOver)
     */
    answerWord?: string | null;
};
export namespace WordleGameResponse {
    /**
     * Game status: 0=in_progress, 10=completed, 20=timed_out
     */
    export enum status {
        '_0' = 0,
        '_10' = 10,
        '_20' = 20,
    }
}

